export enum SimulationTypes {
  SLOTTED,
  PERFORATED
}
